import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { DepositTransactionType, WalletTransaction } from "@/types/TransactionsType"
import {
  GET_ADD_TRANSACTIONS_BY_COMPANY_URL,
  GET_ADD_TRANSACTIONS_CREDIT_URL,
  GET_ADD_TRANSACTIONS_DEBIT_URL,
  GET_ADD_TRANSACTIONS_URL,
  GET_PENDING_REQUESTS_URL,
  REJECT_TRANSACTION_URL,
  VALIDATE_TRANSACTION_URL,
} from "@/constants/api/endpoints"
import { http } from "@/utils/http"


// Todo review the response from the update an the create function

// Fetch all transactions
export const fetchTransactions = createAsyncThunk<WalletTransaction[]>("transactions/fetchTransactions", async (_, thunkApi) => {
  return http
    .get<WalletTransaction[]>(GET_ADD_TRANSACTIONS_URL)
    .then((res) => res.data)
    .catch(e => {
      return thunkApi.rejectWithValue({ data: e.data })
    })
})

// Create a transaction by the client (without the need of the manager to create it for them)company 

export const fetchTransactionsByCompany = createAsyncThunk<WalletTransaction, { id: string }>(
  "transactions/fetchTransactionsByCompany",
  async ({ id }: { id: string }, thunkApi) => {
    return http
      .get<WalletTransaction>(GET_ADD_TRANSACTIONS_BY_COMPANY_URL.replace(":id", `${id}`))
      .then((res) => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)
export const fetchPendingRequest = createAsyncThunk<WalletTransaction[], void>(
  "transactions/fetchPendingRequest",
  async (_, thunkApi) => {
    return http
      .get<WalletTransaction[]>(`${GET_PENDING_REQUESTS_URL}`)
      .then((res) => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)


export const transactionsCreditCustomer = createAsyncThunk<WalletTransaction, DepositTransactionType>(
  "transactions/transactionsCreditCustomer",
  async (data: Partial<DepositTransactionType>, thunkApi) => {
    return http
      .post<WalletTransaction>(GET_ADD_TRANSACTIONS_CREDIT_URL, data)
      .then((res) => res.data)
      .catch((e) => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

export const transactionsDebitCustomer = createAsyncThunk<WalletTransaction, DepositTransactionType>(
  "transactions/transactionsDebitCustomer",
  async (data: Partial<DepositTransactionType>, thunkApi) => {
    return http
      .post<WalletTransaction>(GET_ADD_TRANSACTIONS_DEBIT_URL, data)
      .then((res) => res.data)
      .catch((e) => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

export const validateTransaction = createAsyncThunk<
  WalletTransaction,
  { id: string, action: string }
>(
  "transactions/validateTransaction",
  async ({ id, action }, thunkApi) => {
    try {
      const response = await http.post<WalletTransaction>(
        VALIDATE_TRANSACTION_URL.replace(":id", id), { action: action },
      )
      return response.data
    } catch (e: any) {
      return thunkApi.rejectWithValue(e.response?.data)
    }
  },
)

export const rejectTransaction = createAsyncThunk<
  any,
  { id: string, action: string, reason: string }
>(
  "transactions/rejectTransaction",
  async ({ id, action, reason }, thunkApi) => {
    console.log("REJECT TRANSACTION", { id, action, reason })
    try {
      const response = await http.post(
        REJECT_TRANSACTION_URL.replace(":id", id),
        { action: action, reason: reason },
      )
      return response.data
    } catch (e: any) {
      return thunkApi.rejectWithValue(e.response?.data)
    }
  },
)

type TransactionsState = {
  transactions: WalletTransaction[],
  transactionsStatus: string,
  transactionsErrors?: any,
  addTransactionsStatus: string,
  pendingRequests: WalletTransaction[],
  pendingRequestsCount: number,
  fetchPendingRequestStatus: string,

}

// initial state
const initialTransactionsState: TransactionsState = {
  transactions: [],
  transactionsStatus: "idle",
  addTransactionsStatus: "idle",
  pendingRequests: [],
  pendingRequestsCount: 0,
  fetchPendingRequestStatus: "idle",
}

const transactionsSlice = createSlice({
  name: "transactions",
  initialState: initialTransactionsState,
  reducers: {},

  extraReducers(builder) {
    // get  all transactions
    builder
      .addCase(fetchTransactions.pending, (state: TransactionsState) => {
        state.transactionsStatus = "loading"
      })
      .addCase(fetchTransactions.fulfilled, (state: TransactionsState, action) => {
        state.transactionsStatus = "succeeded"
        state.transactions = action.payload
      })
      .addCase(fetchTransactions.rejected, (state: TransactionsState, action) => {
        state.transactionsStatus = "failed"
        state.transactionsErrors = action.error
      })

    builder
      .addCase(fetchTransactionsByCompany.pending, (state: TransactionsState) => {
        state.addTransactionsStatus = "loading"
      })
      .addCase(fetchTransactionsByCompany.fulfilled, (state: TransactionsState, action) => {
        state.addTransactionsStatus = "succeeded"
        state.transactions = action.payload

      })
      .addCase(fetchTransactionsByCompany.rejected, (state: TransactionsState, action) => {
        state.addTransactionsStatus = "failed"
      })

    builder
      .addCase(transactionsCreditCustomer.pending, (state: TransactionsState) => {
        state.addTransactionsStatus = "loading"
      })
      .addCase(transactionsCreditCustomer.fulfilled, (state: TransactionsState, action) => {
        state.addTransactionsStatus = "succeeded"
        state.transactions = [action.payload, ...state.transactions]

      })
      .addCase(transactionsCreditCustomer.rejected, (state: TransactionsState, action) => {
        state.addTransactionsStatus = "failed"
      })

    builder
      .addCase(transactionsDebitCustomer.pending, (state: TransactionsState) => {
        state.addTransactionsStatus = "loading"
      })
      .addCase(transactionsDebitCustomer.fulfilled, (state: TransactionsState, action) => {
        state.addTransactionsStatus = "succeeded"
        state.transactions = [action.payload, ...state.transactions]

      })
      .addCase(transactionsDebitCustomer.rejected, (state: TransactionsState, action) => {
        state.addTransactionsStatus = "failed"
      })

    builder
      .addCase(fetchPendingRequest.pending, (state: TransactionsState) => {
        state.fetchPendingRequestStatus = "loading"
      })
      .addCase(fetchPendingRequest.fulfilled, (state: TransactionsState, action) => {
        state.fetchPendingRequestStatus = "succeeded"
        state.pendingRequests = action.payload
        state.pendingRequestsCount = action.payload.length
      })
      .addCase(fetchPendingRequest.rejected, (state: TransactionsState, action) => {
        state.fetchPendingRequestStatus = "failed"
      })
    builder
      .addCase(validateTransaction.fulfilled, (state: TransactionsState, action) => {
        const index = state.transactions.findIndex(tx => tx.id === action.payload.id)
        if (index !== -1) {
          state.transactions[index] = action.payload
        }
        // Also update in pendingRequests
        state.pendingRequests = state.pendingRequests.filter(tx => tx.id !== action.payload.id)
        state.pendingRequestsCount = state.pendingRequests.length
      })

    builder
      .addCase(rejectTransaction.fulfilled, (state: TransactionsState, action) => {
        const index = state.transactions.findIndex(tx => tx.id === action.payload.id)
        if (index !== -1) {
          state.transactions[index] = action.payload
        }
        // Also update in pendingRequests
        state.pendingRequests = state.pendingRequests.filter(tx => tx.id !== action.payload.id)
        state.pendingRequestsCount = state.pendingRequests.length
      })
  },
})

export default transactionsSlice.reducer

